import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {Check, Error} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import QualityInspection from "../../../../../../entity/emergency/QualityInspection";

export default function ({onChange}) {

    const handleClick = response => () => onChange(response);

    return (
        <Box mt={10}>
            <Typography>Le rendez-vous est dans plus de 2 heures, est ce à la demande du sociétaire ?</Typography>

            <Box mt={5}>
                <Button
                    startIcon={<Check/>}
                    variant="contained"
                    size="small"
                    fullWidth
                    onClick={handleClick(QualityInspection.APPOINTMENT_PLANNING_INITIATOR_BENEFICIARY)}
                    data-test="confirm-appointment"
                >
                    Oui
                </Button>
            </Box>
            <Box mt={5}>
                <Button
                    startIcon={<Error/>}
                    variant="contained"
                    size="small"
                    fullWidth
                    color="error"
                    onClick={handleClick(QualityInspection.APPOINTMENT_PLANNING_INITIATOR_COMPANY)}
                >
                    Non
                </Button>
            </Box>
        </Box>
    )
}